/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_End_ButtonInputs */

const vi_trip_end_button = /** @type {(inputs: Trip_End_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trả xe / Kết thúc chuyến`)
};

/**

* @param {Trip_End_ButtonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_end_button = /** @type {((inputs?: Trip_End_ButtonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_End_ButtonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_end_button(inputs)
});